
<form [formGroup]="formGroup">
  <label for="folderId"><h4><mat-icon>description</mat-icon>&nbsp;Format du fichier FEC</h4></label>
  <mat-form-field class="full-width">
    <mat-label>Format du fichier FEC</mat-label>
    <mat-select formControlName="outputFormat" required>
        <mat-option 
            *ngFor="let format of fecOutputFormatList"
            [value]="format.value">
            {{format.label}}
        </mat-option>
    </mat-select>
  </mat-form-field>
  <app-basic-load-configuration-options
    [formGroup]="formGroup"
    [configuration]="configuration"
    [configurationMode]="configurationMode">
  </app-basic-load-configuration-options>
</form>